<template>
  <div id="time-analysis">


    <div class="time-heatmap">
      <div class="panel-heading">
        <h4 id="poi-visit-time" class="chart-heading">
          POI VISIT TIME
          <info-tooltip text="This graph illustrates the times in which a visit was performed per day/hour"/>
          <hr>
        </h4>
      </div>

      <div class="heatmap-block">
        <div class="barchart-hours"></div>
        <div class="heatmap"></div>
        <div class="barchart-days"></div>
      </div>

      <div class="legend-container">
        <div class="legend legend--heatmap">
          <svg width="500" height="50">
          </svg>
        </div>
      </div>
    </div>


    <hr>
    <div class="time-dwell_time" id="dwell-time-block container">
      <h4 id="poi-visit-time" class="chart-heading">
        DWELL TIME
        <info-tooltip text="Dwell Time of in store visits"/>
        <hr>
      </h4>

      <p id="poi-dwell-time-reset">
        <button type="button" class="reset-filters btn btn-primary">Reset filters</button>
      </p>
      <p id="poi-dwell-time-legend">
        <svg height="25px">
          <g class="dc-legend" transform="translate(0,0)">
            <g class="dc-legend-item" transform="translate(0,0)">
              <rect width="12" height="12" fill="#a7d0f3"></rect>
              <text x="14" y="10.5">Exposed</text>
            </g>
            <g class="dc-legend-item" transform="translate(90,0)">
              <rect width="12" height="12" fill="#3182bd"></rect>
              <text x="14" y="10.5">Control</text>
            </g>
          </g>
        </svg>
      </p>


      <div class="dwell-time-charts-container">
        <div class="dwell-time-charts-barchart-container">
          <div id="dwell-barchart"></div>
        </div>
        <div class="dwell-time-charts-pie-container">
          <h5>
            Dwell Time by Daypart
            <info-tooltip text="Dwell Time divided per time of day. Click on one or more class to apply the filter."/>
          </h5>
          <div id="dwell-pie-day"></div>

          <h5>
            Dwell Time by Weekdays and Weekends
            <info-tooltip text="Dwell Time divided per Weekdays or Weekends. Click on one or more class to apply the filter."/>
          </h5>
          <div id="dwell-pie-week"></div>
        </div>
      </div>
    </div>


    <hr>
    <div class="time-impression_visit" id="time-impression-visit">
      <h4 id="poi-visit-time" class="chart-heading">
        TIME BETWEEN IMPRESSION AND VISIT
        <info-tooltip text="This chart represents the interval between the time when the impression was received and when the user visited the store."/>
        <hr>
      </h4>
      <div id="time-impression-barchart"></div>
    </div>
  </div>

</template>

<script>
/* eslint-disable */

import dc from 'dc';
import Heatmap from '@/modules/charts/heatmap';
import InfoTooltip from '../widgets/InfoTooltip';

let crossfilter = dc.crossfilter;


export default {
  name: 'time-analysis',
  data () {
    return {
      hasMissingDayHours: false
    };
  },
  components: {
    InfoTooltip
  },
  beforeRouteLeave(to, from, next) {
    this.$splashScreen.tabEnabled = true;
    next();
  },
  mounted: function() {
    this.$splashScreen.tabEnabled = false;
    this.$cursorSpinner.processing = false;
    this.$nextTick(() => {
      this.fetchData();
      this.$_am.logEvent("visit",this.$route.name,"time-analysis",new Date().toISOString())
    })
  },
  methods: {
    fetchData: function() {
      var self = this;
      self.$dataStore.csv('time_analysis_heatmap.csv', function(csv) {
        var result = (new Heatmap()).fillHoursDays(csv)
        if (result.hasMissingDayHours) {
          self.hasMissingDayHours = true
          csv = result.newDataset
        }

        self.initHeatmapTime(null, csv);
        self.$dataStore.csv('time_analysis_dwell_expanded.csv', function(csv) {
          self.initDwellTimeGroup(null, csv);
          self.$dataStore.csv('time_analysis_impression_visit.csv', function(csv) {
            self.initImpressionVisit(null, csv);
          });
        });
      });
    },

    initHeatmapTime: function(ctx, data) {
      var _self = this;
      var blockContext = '.time-heatmap';
      var rangeWithZero = ['#8080801a', '#e5e4e5', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081', '#063059', '#1C2B35'];

      var heatmapTimeVisitKlass = new Heatmap({
        enable_controls: false,
        legend: {width: 400, shapeWidth: 40}
      });


      heatmapTimeVisitKlass.processDataFormat = function(data) {
        data.forEach(function(d) {
          d.day = d.day === "7" ?  6 : (6 - d.day);
          d.hour = +d.hour;
        });
      };

      heatmapTimeVisitKlass.getDimensions = function (crossfilter) {
        var _self = this;
        var ndx = crossfilter ? crossfilter : _self.ndx;

        return {
          day_hour: ndx.dimension((d) => { return [+d.hour, +d.day]; }),
          day: ndx.dimension((d) => { return +d.day; }),
          hour: ndx.dimension((d) => { return +d.hour; }),
          bucket: ndx.dimension((d) => { return d.bucket; })
        };
      };

      heatmapTimeVisitKlass.setHeatmapRowsLabel = function (i) {
        var _self = this;
        return _self.WDAY_LABELS[i === 6 ? 6 : 5 - i];
      };

      heatmapTimeVisitKlass.render(blockContext, data);
      _self.$reportSettings.setVisibility();
    },

    initDwellTimeGroup: function(ctx, data) {
      var self = this;

      var dwellTimeGroup = "dwellTimeGroup";
      var pieChartDay = dc.pieChart("#dwell-pie-day", dwellTimeGroup);
      var pieChartWeek = dc.pieChart("#dwell-pie-week", dwellTimeGroup);

      const BAR_PADDING = .0; // Percentage the padding will take from the bar
      const RANGE_BAND_PADDING = .5; // Padding between 'groups'
      const OUTER_RANGE_BAND_PADDING = 0.5; // Padding from each side of the chart

      data.forEach(function (d) {
        d.value = +d.value;
        d.controlGroupValue = +d.controlGroupValue;
      });

      var ndx = crossfilter(data),
          dimensions = {
            expose_control: ndx.dimension((d) => { return d.interval; }),
            day: ndx.dimension((d) => { return d.hour; }),
            week: ndx.dimension((d) => { return d.day; }),
          },
          percentageDayGroup = dimensions.day.group().reduceSum((d) => { return d.value; }),
          percentageWeekGroup = dimensions.week.group().reduceSum((d) => { return d.value; })

      let percentageExposeControlGroup = dimensions.expose_control.group().reduce(
        /* callback for when data is added to the current filter results */
        function (p, v) {
          ++p.count;
          p.exposed += v.value;
          p.controled += v.controlGroupValue;
          p.serieKey[v.interval] = p.serieKey[v.interval] ? p.serieKey[v.interval] : [];
          p.serieKey[v.interval].push({key: 'controlled', value: v.controlGroupValue}, {key: 'exposed', value: v.value});

          p.serieKeySum[v.interval] = [{key: 'controlled', value: p.controled}, {key: 'exposed', value: p.exposed} ];
          return p;
        },
        /* callback for when data is removed from the current filter results */
        function (p, v) {
          --p.count;
          p.exposed -= v.value;
          p.controled -= v.controlGroupValue;
          p.serieKey[v.interval] = p.serieKey[v.interval] ? p.serieKey[v.interval] : [];
          p.serieKey[v.interval].push({key: 'controlled', value: v.controlGroupValue}, {key: 'exposed', value: v.value});

          p.serieKeySum[v.interval] = [{key: 'controlled', value: p.controled}, {key: 'exposed', value: p.exposed} ];
          return p;
        },
        /* initialize p */
        function () {
          return {count: 0, exposed: 0, controled: 0, serieKey: {}, serieKeySum: {} };
        }
      );

      let dwellTimeChart = dc.compositeChart("#dwell-barchart", dwellTimeGroup);

      let sizing = chart => {
        let chartContainer = $('#dwell-barchart');
        chart
          .width(chartContainer.width())
          .height(chartContainer.height())
          .redraw();
      };

      var svgClipPathFix = function() {
        var svgBars = $('#dwell-barchart > svg > g > g.sub > g > g > rect');
        svgBars.each(function(k,i) {
          $(i).attr('clip-path', '');
        });


        //Safari specific transform overwrite
        if (navigator && (/.*Version.*Safari.*/.test(navigator.userAgent))) {
          var subBarChart1 = d3.select('#dwell-barchart').selectAll('svg > g > g.sub > g')[0][0];
          $(subBarChart1).attr('transform', 'translate(60, 10)');
        }

        if (d3.select('#dwell-barchart').selectAll('rect')[0]) {
          var k = d3.select('#dwell-barchart').selectAll('rect')[0][0];
          d3.select(k).node().dispatchEvent(new MouseEvent("click"));
          d3.select(k).node().dispatchEvent(new MouseEvent("click"));
        }
      };

      let resizing = chart => window.onresize = () => sizing(chart);

      let barPadding;
      let scaleSubChartBarWidth = chart => {
        let subs = chart.selectAll(".sub");

        if (typeof barPadding === 'undefined') { // First draw only
          // To percentage
          barPadding = BAR_PADDING / subs.size() * 100;
          // Each bar gets half the padding
          barPadding = barPadding / 2;
        }

        let startAt, endAt,
          subScale = d3.scale.linear().domain([0, subs.size()]).range([0, 100]);

        subs.each(function (d, i) {
          startAt = subScale(i + 1) - subScale(1);
          endAt = subScale(i + 1);

          startAt += barPadding;
          endAt -= barPadding;

          // polygon(
          //  top-left-vertical top-left-horizontal,
          //  top-right-vertical top-right-horizontal,
          //  bottom-right-vertical bottom-right-horizontal,
          //  bottom-left-vertical bottom-left-horizontal,
          // )
          try {
            if (d3.select(this) && d3.select(this).selectAll('rect')) {
              d3.select(this).selectAll('rect').attr("clip-path", `polygon(${startAt}% 0, ${endAt}% 0, ${endAt}% 100%, ${startAt}% 100%)`);
              d3.select(this).selectAll('rect').css("clip-path", `polygon(${startAt}% 0, ${endAt}% 0, ${endAt}% 100%, ${startAt}% 100%)`);
            }
          } catch (e) {}

        });
      };

      let barChart1 = dc.barChart(dwellTimeChart)
        .barPadding(0)
        .keyAccessor((d) => { return d.key; })
        .valueAccessor(d => { return d.value.serieKeySum[d.key][1].value * 100; })
        .title(d => {return `${d.key}\n\n  Exposed: ${(Number(d.value.exposed)* 100).toFixed(2)}%\n  Control: ${(Number(d.value.controled)* 100).toFixed(2)}%`;})
        .colors(['#ffff']);


      let barChart2 = dc.barChart(dwellTimeChart)
        .barPadding(0)
        .keyAccessor((d) => { return d.key; })
        .valueAccessor(d => {return d.value.serieKeySum[d.key][0].value * 100; })
        .title(d => {return `${d.key}\n\n  Exposed: ${(Number(d.value.exposed)* 100).toFixed(2)}%\n  Control: ${(Number(d.value.controled)* 100).toFixed(2)}%`;})
        .colors(['#57B4F0']);



      dwellTimeChart
        .shareTitle(false)
        .height(480)
        .width(640)
        .renderHorizontalGridLines(true)
        .dimension(dimensions.expose_control)
        .group(percentageExposeControlGroup)
        ._rangeBandPadding(RANGE_BAND_PADDING)
        ._outerRangeBandPadding(OUTER_RANGE_BAND_PADDING)
        .x(d3.scale.ordinal())
        .y(d3.scale.linear().domain([0, 100]))
        .xUnits(dc.units.ordinal)
        .compose([barChart1, barChart2])
        .ordering((d) => { return +d.key.split(/-|\+/)[0]; })
        .on("pretransition", chart => {
            scaleSubChartBarWidth(chart);
        })
        .on("preRedraw", chart => {
            chart.rescale();
        })
        .on("preRender", chart => {
            chart.rescale();
        })
        .on("postRedraw", chart => {
          svgClipPathFix();
        })
        .render();


      sizing(dwellTimeChart);
      resizing(dwellTimeChart);

      pieChartDay
        .width(350)
        .height(150)
        .slicesCap(4)
        .radius(150)
        .legend(dc.legend())
        .dimension(dimensions.day)
        .group(percentageDayGroup)
        // Workaround for #703: not enough data is accessible through .label() to display percentages
        .on('pretransition', function(chart) {
          chart.selectAll('text.pie-slice').text(function(d) {
            var groupPercentage = Math.round(dc.utils.printSingleValue((d.endAngle - d.startAngle) / (2*Math.PI) * 100));
            return groupPercentage === 0 ? "" : groupPercentage + '%';
          })
        });


      var pieChartDay_dRedraw = pieChartDay._doRedraw
      pieChartDay._doRedraw = function() {
        var _cannotRedraw = _.compact(pieChartDay.data().map(
          function(i) {
            if (i.value === 0) {
              return i;
            }
          })).length > 0;

        if (!_cannotRedraw) {
          pieChartDay_dRedraw()
        }
      };

      pieChartDay.render();


      let pieChartWeekMapping = d3.scale.ordinal()
        .domain(['weekday', 'weekend'])
        .range(['#80ca95', '#abdbb6']);

      pieChartWeek
        .width(350)
        .height(150)
        .slicesCap(4)
        .radius(150)
        .legend(dc.legend())
        .dimension(dimensions.week)
        .group(percentageWeekGroup)
        .colors(pieChartWeekMapping)
        // Workaround for #703: not enough data is accessible through .label() to display percentages
        .on('pretransition', function(chart) {
          chart.selectAll('text.pie-slice').text(function(d) {
            return Math.round(dc.utils.printSingleValue((d.endAngle - d.startAngle) / (2*Math.PI) * 100)) + '%';
          })

          $('.dwell-time-charts-pie-container .dc-legend-item text').each(function(idx, elt) {
            var $elt = $(elt);
            var content = $elt.html();
            $elt.html(content[0].toUpperCase() + content.slice(1));
          });
        });


      var pieChartWeek_dRedraw = pieChartWeek._doRedraw
      pieChartWeek._doRedraw = function() {
        var _cannotRedraw = _.compact(pieChartWeek.data().map(
          function(i) {
            if(i.value === 0) {
              return i;
            }
          })).length > 0;

        if (!_cannotRedraw) {
          pieChartWeek_dRedraw()
        }
      };

      pieChartWeek.render();



      // Workaround dwell time filter click as group and not single bar
      let _onClick1 = barChart1.onClick;
      let _onClick2 = barChart2.onClick;

      barChart1.onClick = (chart) => {
        _onClick1(chart);
        _onClick2(chart);
      };

      barChart2.onClick = (chart) => {
        _onClick1(chart);
        _onClick2(chart);
      };



      // Reset pie charts fill style to initial color when deselected
      $('.pie-slice-group g path').each(function(i, el) {
        $(el).css({fill: $(el).attr('fill')});
      });

      let resetButton = $('#poi-dwell-time-reset > button');

      resetButton.on('click', function(e) {
        barChart1.filterAll();
        barChart2.filterAll();

        pieChartDay.filterAll();
        pieChartWeek.filterAll();

        dwellTimeChart.redraw();
        pieChartDay.redraw();
        pieChartWeek.redraw();
      });

      svgClipPathFix();

      self.$reportSettings.setVisibility();
    },

    initImpressionVisit: function(ctx, data) {
      var self = this;
      var impVisitChart = dc.barChart('#time-impression-barchart');
      var yMax = 0;

      data.forEach((d) => {
        d.time = Number(d.time);
        if (100 * d.time > yMax) { yMax = 10 * Math.ceil((10 * d.time)); }
      });

      var ndx = crossfilter(data),
          dimensions = { visit_interval: ndx.dimension((d) => { return d.interval; }) },
          impVisitGroup = dimensions.visit_interval.group().reduceSum((d) => { return d.time * 100 });

      impVisitChart
        .brushOn(false)
        .width(12 * 80 + 80)
        .height(27 * 10 + 40)
        .group(impVisitGroup)
        .renderHorizontalGridLines(true)
        .dimension(dimensions.visit_interval)
        .y(d3.scale.linear().domain([0, yMax || 100]))
        .x(d3.scale.ordinal())
        .xUnits(dc.units.ordinal)
        .ordering((d) => { return +d.key.split(/-|\+/)[0]; })
        .title((d) => { return Number(d.value).toFixed(2) + "%"; })
        .label((d) => { return Number(d.y).toFixed(2) + "%"; });
      impVisitChart.render();

      self.$reportSettings.setVisibility();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="sass">
  @import '../../assets/css/charts/heatmap.scss'
  @import '../../assets/css/tabs/time-analysis.scss'
</style>



// WEBPACK FOOTER //
// src/components/tabs/TimeAnalysis.vue